import { UseDisclosureReturn } from '@chakra-ui/react';
import { BaseFormPopover, useHookForm } from '@invara-dev/react-base';
import { agentStatusType } from '../../../features/workflow/types';
import { useWorkflowSocket } from '../../../features/workflow/hub/useWorkflowSocket';
import { ReactNode } from 'react';

type StatusMessageFrom = { message: string };
export const StatusForm = (props: {
  isDraggable?: boolean;
  userName?: string;
  userId: string;
  disclosure: UseDisclosureReturn;
  trigger: ReactNode;
}) => {
  const invoke = useWorkflowSocket((r) => r.invoke);
  const { formMethods, fieldHelper } = useHookForm<Partial<StatusMessageFrom>>();
  const fields = [fieldHelper.textInput('message').withValidation({ required: {} })];
  return (
    <BaseFormPopover
      trigger={props.trigger}
      disclosure={props.disclosure}
      formMethods={formMethods}
      fields={fields}
      onSubmit={async (d) => {
        await invoke('UpdateStatus', agentStatusType.Away, props.userId, d.message);
        props.disclosure.onClose();
      }}
      header={`Set Status Message ${props.userName ? 'For ' + props.userName : ''}`}
    />
  );
};
